<template>
  <div class="cm-success">
    <!-- Front side -->
    <div class="cm-success-front">
      <svg
        class="cm-success-icon"
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <circle
          cx="40"
          cy="40"
          r="35"
          fill="#10B981"
          fill-opacity="0.10"
          stroke="#10B981"
          stroke-width="3"
        />
        <path
          d="M26 40L36 50L54 32"
          stroke="#10B981"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <div class="cm-success-text">
        <h3 class="cm-success-title">{{ t('contactForm.successTitle') }}</h3>
        <p class="cm-success-msg">{{ t('contactForm.successMessage') }}</p>
      </div>
    </div>

    <!-- Back side (thank you) -->
    <div class="cm-success-back">
      <div class="cm-thank-you-content">
        <div class="cm-sparkles">
          <div class="cm-sparkle cm-sparkle-1">✨</div>
          <div class="cm-sparkle cm-sparkle-2">⭐</div>
          <div class="cm-sparkle cm-sparkle-3">✨</div>
          <div class="cm-sparkle cm-sparkle-4">🌟</div>
          <div class="cm-sparkle cm-sparkle-5">✨</div>
        </div>
        <h3 class="cm-thank-you-title">{{ t('contactForm.successTitle') }}</h3>
        <p class="cm-thank-you-msg">{{ t('contactForm.successMessage') }}</p>
        <div class="cm-heart">💚</div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n'
  const { t } = useI18n({ useScope: 'global' })
</script>
